export default {
  newDesign: true,
  parameters: {
    landing_id: "LatQuScoG2",
    segment: 14,
    randomizeQuestions: { from: 2, to: 13 },
  },
  title:
    "Responde las preguntas para inscribirte en tu primera clase de prueba | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "Responde las preguntas para inscribirte en tu primera clase de prueba",
    subtitle:
      "Transformamos la pasión por la tecnología en una ventaja:<br>💬 Descubre los talentos de tu hijo de forma divertida<br>🌐 Solo necesitas una computadora y conexión a internet",
    image: {
      url: "/welcome/sp_longquiz_dev_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/sp_longquiz_dev_v2_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "¡Empecemos! 🔥",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  customStopPages: {
    child: {
      title:
        "Lamentablemente, solo un padre o tutor puede inscribir a un estudiante en las clases.",
      subtitle:
        "Si quieres continuar, puedes compartir este enlace con tus padres.<br>¡Ojalá podamos verte pronto en nuestras clases! ",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "¿Quién está respondiendo el cuestionario?",
      answers: [
        "👨‍👩‍👧 Padre / madre / tutor",
        {
          answer: "👦👧 Niño / niña",
          stopAnswer: true,
          customStopPageId: "child",
        },
      ],
    },
    2: {
      title: "¿Qué edad tiene tu hijo o hija?",
      type: "age",
      button: "",
    },
    3: {
      question: "¿Cuentan con una computadora o laptop para clases en línea?",
      answers: [
        "💻 Sí, computadora o laptop",
        "📱 Solo teléfono o tablet",
        {
          answer: "❌ No tenemos dispositivo",
          stopAnswer: true,
        },
      ],
    },
    4: {
      question:
        "¿Tu hijo o hija ha intentado aprender programación alguna vez?",
      answers: ["👾 Sí", "🙅‍♀️ No", "🤔 No estoy seguro/a"],
    },
    5: {
      question: "¿Tu hijo o hija es niño o niña?",
      answers: ["🧒 Niño", "👧 Niña"],
    },
    6: {
      question: "¿Tu hijo o hija ha tomado clases en línea antes?",
      answers: [
        "💪 Sí, de forma regular",
        "🧠 Sí, solo una vez o por poco tiempo",
        "🚫 No, todavía no",
      ],
    },
    7: {
      question:
        "Si las clases resultan útiles, ¿considerarías pagar por ellas?",
      answers: [
        "💵 Sí, lo estamos contemplando",
        "🤷‍♂️ No estamos seguros, necesitamos más información",
        "💰 Solo si el precio es razonable",
        "🙅‍♀️ No, no planeamos pagar aunque nos guste",
      ],
    },
    8: {
      question: "¿Qué tan estable es la conexión a internet en tu casa?",
      answers: [
        "🌐 Es estable",
        "⚡️ A veces se interrumpe",
        "📶 Se interrumpe con frecuencia",
      ],
    },
    9: {
      question:
        "¿Qué presupuesto mensual te parece razonable para la educación de tu hijo o hija?",
      financial: true,
      answers: [
        "💸 Hasta 30 USD",
        "💳 30–60 USD",
        "💵 60–100 USD",
        "💎 Más de 100 USD",
      ],
    },
    10: {
      question:
        "¿Cuánto solías gastar al mes en actividades extracurriculares para tu hijo o hija?",
      answers: [
        "🚫 No gastábamos nada",
        "💰 20–50 USD",
        "💵 50–100 USD",
        "💎 Más de 100 USD",
      ],
    },
    11: {
      question:
        "¿Cómo crees que reaccionaría tu hijo o hija si le propusieras una clase de programación de prueba?",
      answers: [
        "🤓 Muestra interés en la programación",
        "🙂 No le interesa, pero podría aceptar probar",
        "⚽️ Preferiría otras actividades (deporte, arte, etc.)",
        "🙅‍♂️ Diría que no quiere hacerlo",
      ],
    },
    12: {
      question: "¿Cómo suele pasar su tiempo libre tu hijo o hija?",
      answers: [
        "🎮 Con pantallas o dispositivos",
        "🏃‍♂️ Realizando juegos activos o al aire libre",
        "🎨 En clubes, clases o deportes",
        "📚 En casa leyendo, creando o con otros pasatiempos",
      ],
    },
    13: {
      question:
        "¿Quién suele decidir a qué actividades o talleres asiste tu hijo o hija?",
      answers: [
        "👩‍🏫 Yo tomo la decisión",
        "👨‍👩‍👧 Lo decidimos junto con el otro padre o madre",
        "👵 Familiares (abuelos, etc.)",
        "🧒 El niño o la niña lo propone",
      ],
    },
    14: {
      title: "🎉 ¡Solo un paso más!",
      typeInfo: "congrats",
      subtitle:
        "Ayuda a tu hijo a explorar su lado creativo con programación y diseño digital.<br>🌟 Ya son más de 200.000 niños creando y aprendiendo con nosotros.",
      button: "📅 ¡Reserva una clase gratis!",
    },
    15: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    16: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    17: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    18: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    19: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
